import React, { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import api, { formatError } from "@/lib/api";
import { AuthShell, Field } from "./Login";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await api.post("/auth/reset-password", { token, password: pw }); setDone(true); }
    catch (e) { setErr(formatError(e)); }
    finally { setLoading(false); }
  };

  if (done) return (
    <AuthShell title="Klaar!" subtitle="Wachtwoord bijgewerkt">
      <Link to="/login" className="text-orange-600 hover:underline" data-testid="reset-success-login">Nu inloggen</Link>
    </AuthShell>
  );

  return (
    <AuthShell title="Nieuw wachtwoord" subtitle="Stel een nieuw wachtwoord in">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <Field label="Nieuw wachtwoord" type="password" value={pw} onChange={setPw} testid="reset-password"/>
        {err && <div className="text-red-600 text-sm">{err}</div>}
        <button type="submit" disabled={loading || !token} className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 rounded-lg disabled:opacity-50" data-testid="reset-submit">
          {loading ? "Bezig..." : "Wachtwoord wijzigen"}
        </button>
      </form>
    </AuthShell>
  );
}

export function VerifyEmail() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const { } = useState();
  const [msg, setMsg] = useState("Bezig met verificatie...");
  useEffect(() => {
    const token = sp.get("token");
    if (!token) { setMsg("Geen token gevonden."); return; }
    api.post("/auth/verify-email", { token })
      .then((r) => {
        localStorage.setItem("gs_token", r.data.token);
        setMsg("Account bevestigd! Je wordt doorgestuurd...");
        setTimeout(() => nav("/"), 1200);
      })
      .catch((e) => setMsg(formatError(e)));
  }, [sp, nav]);

  return (
    <AuthShell title="E-mail bevestigen" subtitle="">
      <div className="text-center py-4" data-testid="verify-status">{msg}</div>
    </AuthShell>
  );
}
